<template>
  <TaskPage no-brand no-back no-action>
    <template #title>Upload my tree</template>
    <h5>Get the app, and follow the instructions. It's easy!</h5>
    <SyncAppTile/>
    <p class="more-info">
      <router-link :to="{ name: 'sync' }">Learn more about the Sync app</router-link>
    </p>
    <template #secondaryAction>
      <button type="button" class="btn btn-outline-primary" @click="router.back()">
        Back
      </button>
    </template>
  </TaskPage>
</template>

<style lang="scss" scoped>
.sync-app-tile {
  margin: 0 1rem;
}

h5 {
  margin: 1rem 0 2rem;
}

.more-info {
  margin-top: 2rem;
  font-size: 0.875rem;
}

.secondary-action button {
  min-width: 100px;
}
</style>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { usePageTitle } from '@webapp/util/AppUtil'
import TaskPage from '@webapp/util/TaskPage.vue'
import SyncAppTile from './SyncAppTile.vue'

const router = useRouter()

usePageTitle('Upload my tree')
</script>
